import { CheckOutlined, DownOutlined, UserOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import useLoginStore from 'store/loginStore';
import icons from 'utils/icons';
import OrgLink from './System/OrgLink';
import useIsMobile from 'hooks/useIsMobile';
import React from 'react';

const UserMenu = ({ hideNameOnMobile = false }) => {
  const { user, logout } = useLoginStore();
  const isAdmin = useLoginStore(s => s.isAdmin)();
  const isMobile = useIsMobile();

  const getUserMenuItems = () => {
    const items = [];
    if (isMobile && hideNameOnMobile) {
      items.push({
        key: 'name',
        label: <span className="text-gray-500">{user.firstName + ' ' + user.lastName}</span>,
        icon: <UserOutlined className="text-gray-500" />,
        disabled: true,
      });

      items.push({
        type: 'divider',
      });
    }

    // Add settings for admin
    if (isAdmin) {
      items.push({
        key: 'settings',
        label: (
          <OrgLink to="/settings">Settings &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</OrgLink>
        ),
        icon: icons.Settings,
      });
    }

    // Add user profile
    items.push({
      key: 'profile',
      label: (
        <OrgLink to="/profile">Edit Profile &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</OrgLink>
      ),
    });

    // Add divider
    items.push({
      type: 'divider',
    });

    // Add logout
    items.push({
      key: 'logout',
      label: 'Logout',
      icon: icons.User,
      onClick: () => { logout() }
    });

    return items;
  }

  return (
    <Dropdown menu={{ items: getUserMenuItems() }} placement="bottomRight" trigger={['click']}>
      <a className="inline-block select-none" onClick={(e) => e.preventDefault()}>
        <UserOutlined className="text-white mr-1" />
        {(!isMobile || !hideNameOnMobile) &&
          <React.Fragment>
            <span className="cursor-pointer text-white">
              {user.firstName + ' ' + user.lastName}
            </span>
            <DownOutlined className="text-white ml-1" />
          </React.Fragment>
        }
      </a>
    </Dropdown>
  )
}

export default UserMenu